import { useEffect } from 'react';
import { useChartContext } from '../components/chart.context';
import { useMacdSeries } from './use-macd-series';
import { useRsiSeries } from './use-rsi-series';
import { fitContent } from './fit-content.hook';

export const useIndicatorChart = () => {
  const { chartRef, indicatorChartRefs, indicatorSeriesRefs, initialLoad } =
    useChartContext();

  useRsiSeries();
  useMacdSeries();

  useEffect(() => {
    return () => {
      Object.values(indicatorChartRefs.current).forEach((chartArray) =>
        chartArray?.forEach((chart) => chart?.remove())
      );
      indicatorChartRefs.current = {};
      indicatorSeriesRefs.current = {};
    };
  }, []);

  useEffect(() => {
    // Fit chart content if it's the initial load
    if (initialLoad) {
      fitContent(chartRef);
    }
  }, [initialLoad]);
};
